import React from 'react';
export const isProduction = () => {
    const PRODUCTION_ENV = 'production';
    let result = false;
    try {
        if (process.env.NODE_ENV === PRODUCTION_ENV) {
            result = true;
        }
    }
    catch (err) { }
    return result;
};
const Text = (props, ref) => {
    const { component = 'span', strong, underline, delete: deleteProp, code, mark, ...others } = props;
    let { children } = props;
    if (typeof children === 'string' && children.indexOf('\n') !== -1) {
        const childrenList = children.split('\n');
        const newChildren = [];
        childrenList.forEach((child) => {
            newChildren.push(child);
            newChildren.push(React.createElement("br", null));
        });
        newChildren.pop();
        children = newChildren;
    }
    const Tag = component;
    if (strong) {
        children = React.createElement("strong", null, children);
    }
    if (underline) {
        children = React.createElement("u", null, children);
    }
    if (deleteProp) {
        children = React.createElement("del", null, children);
    }
    if (code) {
        children = React.createElement("code", null, children);
    }
    if (mark) {
        children = React.createElement("mark", null, children);
    }
    return (React.createElement(Tag, Object.assign({}, others, { ref: ref }), children));
};
export default React.forwardRef(Text);
